type ThemeAction = {
  type: "SET_THEME";
  payload: { selectedTheme: string };
};

type ThemeState = {
  selectedTheme?: string;
};

const theme = (state: ThemeState = {}, action: ThemeAction): ThemeState => {
  switch (action.type) {
    case "SET_THEME":
      const { selectedTheme } = action.payload;
      return {
        ...state,
        selectedTheme
      };
    default:
      return state;
  }
};

export default theme;
